import { render, staticRenderFns } from "./PermMembersDialog.vue?vue&type=template&id=59eb5c10&"
import script from "./PermMembersDialog.vue?vue&type=script&lang=ts&"
export * from "./PermMembersDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PermMembersDialog.vue?vue&type=style&index=0&id=59eb5c10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports